module.exports = __webpack_public_path__ + "static/freeagent-74349829d4b3b4141730489575c5ea5c.png";